import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiConfig } from '../../core/api-config';
import { OrderModel } from '../../core/models';
import { VOCCourseModel } from 'src/app/core/VOCCourseModel';
import { ShortCourseOrderModel } from 'src/app/core/ShortCourseOrderModel';
import { ShortCourseConfirmationModel } from 'src/app/components/booking-confirmation/booking-confirmation.component';

@Injectable({ providedIn: 'root' })
export class OrderService {
  constructor(private http: HttpClient) { }

  createStripeCheckout(request: any): Observable<any> {
    const endpoint = request.clusterPricingVersion === 1 ? 'create-cluster-stripe-checkout' : 'create-stripe-checkout';
    return this.http.post<any>(`${ApiConfig.baseUrl}/orders/${endpoint}`, request);
  }

  createNormalOrder(request: any): Observable<OrderModel> {
    const endpoint = request.clusterPricingVersion === 1 ? 'create-cluster-normal-order' : 'create-normal-order';
    return this.http.post<OrderModel>(`${ApiConfig.baseUrl}/orders/${endpoint}`, request);
  }

  getClusterCheckoutResult(sessionId: string): Observable<OrderModel> {
    return this.http.get<OrderModel>(`${ApiConfig.baseUrl}/orders/cluster-checkout-result`, { params: { sessionId } });
  }

  OrderComplete(bookingReference: string): Observable<OrderModel[]> {
    return this.http.get<OrderModel[]>(
      `${ApiConfig.baseUrl}/orders/order-complete`,
      {
        params: {
          bookingReference: bookingReference
        }
      }
    );
  }



  getMyOrders(): Observable<OrderModel[]> {
    return this.http.get<OrderModel[]>(`${ApiConfig.baseUrl}/orders/my-orders`);
  }


  shortCourseOrderComplete(
    orderId: number,
    type: string,
    shortCourseDetails: ShortCourseConfirmationModel
  ): Observable<string> {

    const params = new HttpParams()
      .set('orderId', orderId.toString())
      .set('type', type);

    return this.http.post(
      `${ApiConfig.baseUrl}/orders/short-order-complete`,
      shortCourseDetails,
      {
        params,
        responseType: 'text'
      }
    );
  }


  //  
  GetAvailableSeatsByIdVetTrackId(vetTrackId: number): Observable<ShortCourseOrderModel> {
    let params = new HttpParams().set('vetTrackId', vetTrackId);
    return this.http.get<any>(`${ApiConfig.baseUrl}/orders/get-seat-count`, { params });
  }

  createStripeShortCheckout(request: any): Observable<any> {
    return this.http.post<any>(`${ApiConfig.baseUrl}/orders/create-stripe-short-checkout`, request);
  }




  // Get public courses with tag and paging.
  getVOCDetails(jobNO: string): Observable<VOCCourseModel> {
    let params = new HttpParams().set('jobNumber', jobNO);
    return this.http.get<any>(`${ApiConfig.baseUrl}/orders/get-voc-details`, { params });
  }


  getPaidRegistrationById(orderId: number) {
    let params = new HttpParams().set('orderId', orderId);
    return this.http.get<any>(`${ApiConfig.baseUrl}/orders/get-paid-order`, { params });
  }


  savePaidRegistration(orderId: number, registrationBody: any) {

    return this.http.post<any>(
      `${ApiConfig.baseUrl}/orders/paid-registration`,
      {
        id: orderId,
        registrationBody:
          registrationBody
      }
    );

  }

}
